// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M1 17.4468C2.73389 16.7309 3.33756 13.9873 4 12C6 6 9 4 12 4C15 4 18 6 20 12C20.6624 13.9873 21.2661 16.7309 23 17.4468V20H15V14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14V20H1V17.4468Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M1 17.4468C2.73389 16.7309 3.33756 13.9873 4 12C6 6 9 4 12 4C15 4 18 6 20 12C20.6624 13.9873 21.2661 16.7309 23 17.4468V20H15V14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14V20H1V17.4468Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge-2')
export default class Bridge2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-2',
    }
  }
}
